var map = {
	"./1-_DSC8309.jpg": 56,
	"./2-_DSC8551.jpg": 57,
	"./3-_DSC8653.jpg": 58,
	"./4-_DSC0673.jpg": 59,
	"./6-_DSC8909.jpg": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;